import React, { memo, useEffect } from "react";
import { useAuth } from "../providers/AuthProvider";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";

const AdminRoute = memo(function AdminRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useAuth();

  useEffect(() => {
    if (session.status === "unauthorized") {
      navigate("/signin/admin");
      return;
    }
    if (session.status === "authorized" && session?.user?.roleCode === "USER") {
      console.log("session", session);

      navigate("/admin/dashboard");
      return;
    }
  }, [session.status, navigate, session?.user?.roleCode]);

  if (session.status === "loading") {
    return <LoadingFallback />;
  }

  console.log(session.status, session?.user?.roleCode);

  return session.status === "authorized" && session?.user?.roleCode === "ADMIN"
    ? children
    : null;
});

export default AdminRoute;
